import * as Constants from '../utilities/constants/Constants';
import { isLaptopsApp } from '../utilities/HelperFunctions/SignageHelperFunctions';
import {
  getElementImagePath,
  isBackgroundTypeElement,
  updateProjectPlacingsCoords
} from './fabricCanvasActions';
import { getPlacings } from './ProjectData/Project';
import { isSignageSuiteProduct } from '../utilities/HelperFunctions/HelperFunctions';
import { doesProjectHasPixelatedImage } from './actions/pixelationHandler';
import { getSharedScenePlacingSizeAndOffset } from './actions/multiWallHandler';

export const renderJSONForWalls = (project, isPreview) => dispatch => {
  const renderJSONList = [];
  project.walls.forEach(wall => {
    const renderJSON = dispatch(renderingJSONForWall(wall, project, isPreview));
    renderJSONList.push(renderJSON);
  });
  return renderJSONList;
};

export const renderingJSONForWall = (wall, project, isPreview) => (
  dispatch,
  getState
) => {
  dispatch(updateProjectPlacingsCoords());
  let projectBackgroundColor = null;
  if (project.backgroundColor) {
    projectBackgroundColor = `#${project.backgroundColor}`;
  }

  let totalPlacings = [];
  const currentWallPlacings = getPlacings(project).filter(
    placing => placing.wallIndex == wall.index && placing.placeable
  );
  totalPlacings = totalPlacings.concat(currentWallPlacings);
  if (!isPreview) {
    totalPlacings = totalPlacings.concat([...wall.placings]);
  }

  let counter = 0;
  const layers = [];
  totalPlacings.forEach(placing => {
    if (!isBackgroundTypeElement(placing) || !projectBackgroundColor) {
      let contentImagePath = dispatch(getElementImagePath(placing));
      let placingValues = { ...placing };
      if (
        getState().fabricCanvas.projectGroupSharedScene &&
        isBackgroundTypeElement(placing)
      ) {
        placingValues = dispatch(getSharedScenePlacingSizeAndOffset(project));
        contentImagePath = placingValues.imagePath;
      }
      const data = {};
      data.x = placingValues.xOffset;
      data.y = placingValues.yOffset;
      data.image = contentImagePath;
      data.angle = placing.angle;
      data.flip = placingValues.flipX;
      data.tiled = placing.tiled;
      data.opacity = placing.opacity ? placing.opacity : 1;
      data.width = placingValues.width;
      data.height = placingValues.height;
      layers[counter++] = data;
    }
  });

  let productColor = null;
  if (
    getState().home.selectedProduct &&
    getState().home.selectedProduct.designerOptions
  ) {
    productColor = `#${
      getState().home.selectedProduct.designerOptions.backgroundColor
    }`;
  } else if (!isSignageSuiteProduct()) {
    productColor = '#fff';
  }

  return {
    projectId: project.id,
    width: project.width,
    height: project.height,
    layers,
    color: productColor,
    backgroundColor: projectBackgroundColor,
    overlay: dispatch(getOverlayImage()),
    blockChain_qr_code: dispatch(getBlockChainQrCodeImage()),
    pixelationWarning: dispatch(getPixelationImage(project))
  };
};

const getBlockChainQrCodeImage = () => (dispatch, getState) => {
  if (
    getState().home.selectedProduct &&
    isLaptopsApp(getState().home.selectedProduct.groupType) &&
    getState().modal.storeData.enableBlockchain_qrCode
  ) {
    return `${
      process.env.REACT_APP_BUILD_URL
    }/miscellaneous_images/QRCode.png?${Date.now()}`;
  }
  return '/missing.png';
};

export const specularValueForFinish = (finish, template) => () => {
  if (finish === Constants.GLOSSSY_FINISHING) {
    return {
      specular: 0x5c5b5b,
      'Scale U': parseFloat(template.scaleU),
      'Scale V': parseFloat(template.scaleV),
      'Offset U': parseFloat(template.offsetU),
      'Offset V': parseFloat(template.offsetV)
    };
  }
  if (finish == Constants.MATTE_FINISHING) {
    return {
      specular: 0x000000,
      'Scale U': parseFloat(template.scaleU),
      'Scale V': parseFloat(template.scaleV),
      'Offset U': parseFloat(template.offsetU),
      'Offset V': parseFloat(template.offsetV)
    };
  }
  return {
    'Scale U': parseFloat(template.scaleU),
    'Scale V': parseFloat(template.scaleV),
    'Offset U': parseFloat(template.offsetU),
    'Offset V': parseFloat(template.offsetV)
  };
};

export const getOverlayImage = () => (dispatch, getState) => {
  const { selectedProduct } = getState().home;
  if (
    selectedProduct &&
    selectedProduct.activeProductSize.activeTemplate.overlayImageUrl
  ) {
    return selectedProduct.activeProductSize.activeTemplate.overlayImageUrl;
  }
  return '/missing.png';
};

export const getPixelationImage = project => dispatch => {
  const hasPixelation = dispatch(doesProjectHasPixelatedImage(project));
  if (hasPixelation) {
    return `${
      process.env.REACT_APP_BUILD_URL
    }/miscellaneous_images/warning_icon_512.png?${Date.now()}`;
  }
  return '/missing.png';
};
